<template>
  <v-card
    id="ot"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">{{title}}</span>

  </v-card-title>
  
<v-banner></v-banner>

  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        v-model="lastpos.ra"
        label="RA"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        v-model="lastpos.dec"
        label="dec"
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        v-model="lastpos.ah"
        label="ah"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        v-model="lastpos.airmass"
        label="airmass"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        v-model="lastpos.st"
        label="st"
      ></v-text-field>
    </v-col>
  </v-row>



{{lastpos.telmarche}}

  <v-data-table
    :search="search"
    :headers="columns"
    :items="targets"
    class="elevation-1"
  >
      <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title></v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>

        <v-spacer></v-spacer>



        <v-dialog
          v-model="dialog"
          :retain-focus="false"
        >


          <template  v-slot:activator="{}">

               

            <v-spacer><h2>Targets List</h2></v-spacer>

      

          </template>
        </v-dialog>
      </v-toolbar>
      </template>


    <template>


    </template>

  </v-data-table>

</v-card>
</template>
<script>
//import { strictEqual } from 'assert';

  
  export default {
    data: () =>({

      tel:{
        lastpos:{"timestamp":"2073-04-01T00:00:00.000Z","st":"12h00m00s","ah":"+6h00m00s","ra":0.0,"dec":0.0,"airmass":0,"telmarche":0,"date":"2073-04-01","time":"00:00:00"},
        targets:[]
      },
      lastpos: {},
      targets : [],

      title: "Pilote",
      dialog:"",
      search:"",

      A_Update_tel : null,
      A_Update_targets : null,

      columns:[
        {
          "text": "Objet",
          "value": "objet",
        },
        {
          "text": "Alpha",
          "value": "alpha",
        },
        {
          "text": "Delta",
          "value": "delta",
        },
        {
          "text": "equ",
          "value": "equ",
        },
        {
          "text": "Magv",
          "value": "magv",
        },
        {
          "text":"Night",
          "value":"nuit" 
        }
        
      ],


    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.get_PosTel();
    this.load_PosTel();
    this.get_Targets();
    this.load_Targets();

    this.A_Update_tel = setInterval(() => {

            this.get_PosTel();
            this.load_PosTel();
    },2000);

    this.A_Update_targets = setInterval(() => {

            this.get_Targets();
            this.load_Targets();
    },2000);
  },

  methods: {



    get_Targets(){

        const othis = this;
        

        this.axios.get( backend_url + "/Pilote/Targets")
        .then((res) => {

            othis.tel.targets = JSON.parse(JSON.stringify(res.data));
            
        })
        .catch(() => {
          console.log("PB with load Targets");
        });
    
    },
    load_Targets(){
      var t_targets = [];
      for(var target of this.tel.targets){
        t_targets.push(target);
      };  
      this.targets = JSON.parse(JSON.stringify(t_targets));
    },

    get_PosTel(){ //{"timestamp":"2022-09-03T20:43:02.000Z","st":"21h37m35s","ah":"+02h59m54s","ra":279.425,"dec":38.8035,"airmass":1.204,"telmarche":3}
      var othis = this;
    //Object.assign(this.editedItem,this.defaultItem);
      this.axios.get(backend_url + "/Pilote/lastpos")
      .then((res) => {
          othis.tel.lastpos = JSON.parse(JSON.stringify(res.data));
          othis.tel.lastpos.date = othis.tel.lastpos.timestamp.split("T")[0];
          const tab = othis.tel.lastpos.timestamp.split("T")[1].split(":");
          othis.tel.lastpos.time = tab[0] + ":" + tab[1];
          othis.lastpos = othis.tel.lastpos;
          
          
      })
      .catch(() => {
        console.log("PB with load POs Tel ha oui?");
      });


    },
    load_PosTel(){
        this.lastpos = this.tel.lastpos;
    }
  }
}
</script>